import { useState } from 'react'
import Modal from '../../../components/Modal'
import { useForm } from 'react-hook-form'
import { useMutation } from '@tanstack/react-query'
import Button from '../../../components/Button'
import Toast from '../../../components/Toast/Toast'
import { sendContactInformation } from '../../../services/publicServices/sendContactInformation'
import informationDemoImage from '../../../assets/information_demo_image.svg'
import { handleHideModal, openNewTab } from '../../../utils'

const initialValues = {
  name: '',
  phone: '',
  email: '',
}

const FreeConsultationModal = () => {
  const [isLoading, setIsLoading] = useState(false)

  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    defaultValues: initialValues,
  })

  const { mutate: sendConsultationRequest } = useMutation(sendContactInformation, {
    onSuccess: ({status}) => {
      if (status === 200) {
        handleHideModal({id: 'free-consultation-modal'})
        Toast({ title: 'Solicitud enviada correctamente. Te contactaremos pronto.' })
        reset(initialValues)
        // Close modal
        const modal = document.getElementById('free-consultation-modal')
        if (modal) {
          const bootstrap = window.bootstrap
          if (bootstrap) {
            const bsModal = bootstrap.Modal.getInstance(modal)
            if (bsModal) {
              bsModal.hide()
            }
          }
        }
      } else {
        Toast({ title: 'Error al enviar la solicitud', icon: 'error' })
      }
      setIsLoading(false)
    },
    onError: () => {
      Toast({ title: 'Error al enviar la solicitud', icon: 'error' })
      setIsLoading(false)
    },
  })

  const onSubmit = (data) => {
    setIsLoading(true)
    const consultationData = {
      ...data,
      plataforma: 'hutrit',
    }
    sendConsultationRequest(consultationData)
  }

  return (
    <Modal
      modalId="free-consultation-modal"
      titleClassName="fw-bolder text-on-bg-primary"
      title="Recibe una asesoría GRATIS"
    >
      <div className="mb-3">
        <p className="text-on-bg-primary">
          Déjanos tus datos para enviarte la información de acceso a nuestra plataforma.
        </p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3">
          <label className="form-label text-on-bg-primary">
            Nombre *
          </label>
          <input
            className="form-control"
            type="text"
            {...register('name', {
              required: 'Este campo es obligatorio',
            })}
          />
          {errors.name && (
            <span className="text-danger font-small">{errors.name.message}</span>
          )}
        </div>
        <div className="mb-3">
          <label className="form-label text-on-bg-primary">
            Teléfono *
          </label>
          <input
            className="form-control"
            type="tel"
            {...register('phone', {
              required: 'Este campo es obligatorio',
            })}
          />
          {errors.phone && (
            <span className="text-danger font-small">{errors.phone.message}</span>
          )}
        </div>
        <div className="mb-3">
          <label className="form-label text-on-bg-primary">
            Correo corporativo *
          </label>
          <input
            className="form-control"
            type="email"
            {...register('email', {
              required: 'Este campo es obligatorio',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Ingresa un correo electrónico válido',
              },
            })}
          />
          {errors.email && (
            <span className="text-danger font-small">{errors.email.message}</span>
          )}
        </div>
        <div className="d-flex justify-content-center mb-3">
          <img
            src={informationDemoImage}
            alt="Demo information"
            style={{
              width: '100%',
              maxWidth: '400px',
              height: 'auto',
              cursor: 'pointer',
              borderRadius: '8px',
            }}
            onClick={() => openNewTab({ url: 'https://calendly.com/reunion-ceo/30min' })}
          />
        </div>
        <div className="d-flex justify-content-center mt-4">
          <Button disabled={isLoading} type="submit">
            {isLoading ? 'Enviando...' : 'Enviar solicitud'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default FreeConsultationModal